const WorkspaceEndpoints = {
  GET_WORKSPACES: "/workspaces/",
  CREATE_WORKSPACE: "/workspaces/",
  EDIT_WORKSPACE: (workspaceId: string) => `/workspaces/${workspaceId}/`,
};

export default WorkspaceEndpoints;
